import { AppHelper } from "../appHelper.js";
import { Helper } from "../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";
import ReactDOM from "react-dom";
export class Nukreis extends React.Component<NukreisProps, any> {
    common = new AppHelper();
    private TYPES_WITH_PRE_AND_SUFFIX = [
        "AD",
        "MA",
        "MT",
        "DE",
        "BN",
        "ER"
    ];
    showCurrentNr = true;
    canEditSufAndPrefix: boolean;
    //Maximaler Integer Wert
    private MAX_VALUE = 2147483647;
    private MIN_VALUE = 1;

    constructor(props: NukreisProps) {
        super(props);
        this.canEditSufAndPrefix = this.TYPES_WITH_PRE_AND_SUFFIX.findIndex(f => f == props.entity.Type) > -1 || Helper.hasValue(props.entity.AuArt);
        this.showCurrentNr = props.entity.Type.toUpperCase() !== "PL";
        this.common.init(this);
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.MinNr":
                if ((Helper.hasValue(this.props.entity.MinNr)) && (((value as number) >= this.props.entity.MaxNr) || (value < this.MIN_VALUE))) {
                    value = this.props.entity.MinNr;
                }
                break;
            case "entity.MaxNr":
                if ((Helper.hasValue(this.props.entity.MaxNr)) && (((value as number) <= this.props.entity.MinNr) || (value > this.MAX_VALUE))) {
                    value = this.props.entity.MaxNr;
                }
                break;
            case "entity.TechMinNr":
                let maxLowerMin = Helper.hasValue(this.props.entity.TechMaxNr) && Helper.hasValue(this.props.entity.TechMinNr) && (value as number) >= this.props.entity.TechMaxNr;
                let minTechLowerMinNormal = value < this.props.entity.MinNr;
                if (value != null && (maxLowerMin || minTechLowerMinNormal)) {
                    NotificationHelper.showWarningMessage(Helper.getTranslation("WebCRM.Nukreis.TechMinNr"));
                    value = this.props.entity.TechMinNr;

                }
                break;
            case "entity.TechMaxNr":
                let minHigherMax = Helper.hasValue(this.props.entity.TechMaxNr) && Helper.hasValue(this.props.entity.TechMinNr) && (value as number) <= this.props.entity.TechMinNr;
                let maxTechHigherNormalMax = value > this.props.entity.MaxNr;
                if (value != null && (minHigherMax || maxTechHigherNormalMax)) {
                    NotificationHelper.showWarningMessage(Helper.getTranslation("WebCRM.Nukreis.TechMaxNr"));
                    value = this.props.entity.TechMaxNr;
                }
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem, () => {
                if (Helper.hasValue(this.props.onChange)) {
                    this.props.onChange(this.props.entity);
                }
            });
    }

    componentDidMount() {
        this.common.updateSheetTitle(this.props.title);
        this.common.updateBrowserTitle(this.props.title);
    }

    private validate = () => {
        return new Promise<boolean>((resolve) => {
            if (!this.common.validate()) {
                resolve(false);
            }

            const entity = this.props.entity;
            if ((Helper.hasValue(entity.TechMinNr) && !Helper.hasValue(entity.TechMaxNr)) || (!Helper.hasValue(entity.TechMinNr) && Helper.hasValue(entity.TechMaxNr))) {
                NotificationHelper.showWarningMessage(Helper.getTranslation("WebCRM.Nukreis.FillTechKreis"))
                resolve(false)
            } else if (entity.CurrentNr >= entity.MinNr && entity.CurrentNr <= entity.MaxNr) {
                resolve(true);
            } else {

                const targetElement = $("<div>");
                $("body").append(targetElement);

                const removeDialog = () => {
                    ReactDOM.unmountComponentAtNode(targetElement[0]);
                    targetElement[0].remove();
                }
                const dialogProps: DialogProps = {
                    title: Helper.getTranslation("Server.NumberRanges.Extended"),
                    width: 850,
                    actions: [
                        {
                            label: Helper.getTranslation("Standard.Abbrechen"),
                            action: () => {
                                resolve(false);
                            },
                            primary: false
                        },
                        {
                            label: Helper.getTranslation("WebCRM.Nukreis.YesBut"),
                            action: () => {
                                resolve(true);
                            },
                            primary: false
                        },
                        {
                            label: Helper.getTranslation("Server.Yes"),
                            action: () => {
                                this.handleFieldChange({ model: "entity.CurrentNr" }, entity.MinNr);
                                resolve(true);
                            },
                            primary: true
                        }
                    ],
                    afterClose: removeDialog
                };
                ReactDOM.render(
                    <Dialog {...dialogProps} open={true}>
                        <label>{Helper.getTranslation("WebCRM.Nukreis.OutOfRange").replace("{value}", entity.MinNr.toString())}</label>
                    </Dialog >, targetElement[0]
                );
            }
        });
    }

    save = async () => {
        const isValid = await this.validate();
        if (isValid) {
            const result = await HTTPService.post<JsonResultClass>("Nukreis/SaveNuKreis", { model: this.props.entity });
            switch (result.Code) {
                case 0:
                    NotificationHelper.showSuccessMessage(result.Message);
                    break;
                case 1:
                    NotificationHelper.showErrorMessage(result.Message);
                    break;
            }
            this.common.handlePostSave(result.Code === 0, false);
        }
    }

    private getNukreisWarningMessage = () => {
        let warningMessage = "";
        if (((Helper.hasValue(this.props.entity.TechMaxNr) || Helper.hasValue(this.props.entity.TechMinNr))) &&
            (this.props.entity.MinNr > this.props.entity.TechMinNr || this.props.entity.MaxNr < this.props.entity.TechMinNr ||
                this.props.entity.MaxNr < this.props.entity.TechMaxNr || this.props.entity.MinNr > this.props.entity.TechMaxNr))
            warningMessage += Helper.getTranslation("WebSMS.Resource.FieldService.NukreisTechnicianOverlap") + "\n";
        return warningMessage;
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        const warningMessage = this.getNukreisWarningMessage();
        if (!Helper.isNullOrEmpty(warningMessage)) {
            NotificationHelper.showWarningMessage(warningMessage);
        }
        return (<>
            <CommonApp {...props} title={this.props.title} />
        </>);
    }
}

export interface NukreisProps extends AppBaseProps {
    entity: NukreisEntity;
    translations: StringKeyDictionary<string>;
    onChange?: (dataItem) => void;
}

export interface NukreisEntity extends Entity {
    Name: string;
    Type: string;
    CurrentNr?: number;
    MinNr?: number;
    MaxNr?: number;
    KNr?: number;
    AuArt?: number;
    Description?: string;
    Prefix?: string;
    Suffix?: string;
    TechMinNr?: number;
    TechMaxNr?: number;
}